import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import config from '../../../config';

class Timer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      shopTime: this.getTime(),
    };
    this.timer = setInterval(() => {
      this.setState({
        shopTime: this.getTime(),
      });
    }, 5000);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state.shopTime !== nextState.shopTime;
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  getTime() {
    return moment().tz(this.props.timezone).format(config.timeFormat);
  }

  render() {
    return (
      <Fragment>
        {this.state.shopTime}
      </Fragment>
    );
  }
}

Timer.propTypes = {
  timezone: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  timezone: state.auth.timezone,
});

export default connect(mapStateToProps)(Timer);
